import { IConfigurationOptionGroup } from '~/domain/IConfigurationOptionGroup';
import { IConfigurationRule } from '~/domain/IConfigurationRule';

import { getDefaultConfigurations } from './defaultConfiguration';
import { cleanupEim, isEimValidLength, parseEim } from './eimParser';
import { findInvalidPackSet } from './validateConfigurationOptions';

export const validateEim = (
  eimPackSets: IConfigurationOptionGroup[],
  packSets: IConfigurationOptionGroup[],
  rules: IConfigurationRule[],
  eim: string):
  [string[] | null, string | null] => {

  if (!isEimValidLength(eim)) {
    return [null, 'EIM must be between 13 and 18 characters'];
  }

  eim = cleanupEim(eim);

  const eimFeatures = parseEim(eim);

  const invalidPackSet = findInvalidPackSet(eimFeatures, eimPackSets);

  if (invalidPackSet) {
    return [null, `EIM does not contain valid input for ${invalidPackSet.name}`];
  }

  try {
    const features = getDefaultConfigurations(packSets, rules, eimFeatures, eimPackSets);
    return [features, null];
  } catch {
    return [null, 'No valid configurations exist for input'];
  }
}
